import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Row, Col, Icon } from 'antd';
import printLogo from '../imgs/print-logo.png';
import { getSex, formatDA } from '../utils';
class PrintReport extends Component {
  static propTypes = {
    server: PropTypes.object,
    report: PropTypes.object,
    history: PropTypes.object,
    reportType: PropTypes.string,
    user: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const roleInfo = (props.user.operationAuths || '').split(',');
    const isAnonymity = roleInfo.indexOf('S') >= 0;
    this.state = {
      report: {},
      printImgs: [],
      isAnonymity,
    };
  }

  componentDidUpdate(prevProps) {
    const { report } = this.props;
    const { diagId } = report;
    const prevDiagId = prevProps.report.diagId;
    if (diagId !== prevDiagId) {
      this.setState({ report });
    }
  }

  render() {
    const { report, isAnonymity } = this.state;
    if (report) {
      //影像所见和诊断建议内容格式转换
      let radiography = report.radiographyDescription || '';
      radiography = radiography.replace(/\r\n/g, '<br />');
      radiography = radiography.replace(/\n/g, '<br />');

      let diagnosis = report.diagnosisDescription || '';
      diagnosis = diagnosis.replace(/\r\n/g, '<br />');
      diagnosis = diagnosis.replace(/\n/g, '<br />');

      const signatureUrl = process.env.PUBLIC_URL + '/imgs/signature/';
      const { institutionId } = report;
      return (
        <div className="preview-report preview-report-margin">
          <div className="title">
            <p className="title-1">{report.reportTitle}</p>
            <p className="title-2">检查报告单</p>
          </div>
          {institutionId === 100109 ? null : (
            <div className="institution report-instution">
              <p>送检机构：{report.institutionName}</p>
              <p>检查日期：{report.studyDateTime}</p>
            </div>
          )}
          <div className="report-user">
            <Row>
              <Col span={12}>
                <p>姓名：{isAnonymity ? '***' : report.patName}</p>
              </Col>
              <Col span={6}>
                <p>性别：{getSex(report.patSex)}</p>
              </Col>
              <Col span={6}>
                <p>年龄：{report.patAge}</p>
              </Col>
              <Col span={12}>
                <p>患者编号：{report.patId}</p>
              </Col>
              <Col span={12}>
                <p>住院号：{report.hospitalizedNumber}</p>
              </Col>
              <Col span={12}>
                <p>床号：{report.bedNum}</p>
              </Col>
              <Col span={12}>
                <p>门诊号：{report.outpatientNum}</p>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <p>检查类型：{report.modality}</p>
              </Col>
              <Col span={12}>
                <p>送检时间：{report.studyDateTime}</p>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <p>检查编号：{report.accessionNumber}</p>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <p>检查部位：{report.applicationItem}</p>
              </Col>
              {report.critical && (
                <Col span={12}>
                  <Icon type="check-square" theme="filled" />
                  危急值
                </Col>
              )}
            </Row>
          </div>

          <Row gutter={60} className="preview-content">
            <Col span={24}>
              <p className="title">影像所见</p>
              <div
                className="content report-cont"
                dangerouslySetInnerHTML={{
                  __html: radiography,
                }}
              ></div>
            </Col>
          </Row>
          <Row className="preview-content">
            <Col span={24}>
              <p className="title">诊断建议</p>
              <div
                className="content report-cont"
                dangerouslySetInnerHTML={{ __html: diagnosis }}
              ></div>
            </Col>
          </Row>
          <div className="printer-footer">
            <div className="print-doctor-names">
              {institutionId === 100109 && (
                <span className="item">检查日期：{report.studyDateTime}</span>
              )}

              <span className="item">
                九峰报告医生：
                {report.reportSignatureImage ? (
                  <img
                    className="signature-img"
                    src={signatureUrl + report.reportSignatureImage}
                    alt=""
                  />
                ) : (
                  report.reportSignature
                )}
              </span>
              {report.verifyUserName && (
                <span className="item">
                  九峰审核医生：
                  {report.verifySignatureImage ? (
                    <img
                      className="signature-img"
                      src={signatureUrl + report.verifySignatureImage}
                      alt=""
                    />
                  ) : (
                    report.verifySignature
                  )}
                </span>
              )}
              {report.verify2Signature && (
                <span className="item">
                  九峰审核医生2：
                  {report.verify2SignatureImage ? (
                    <img
                      className="signature-img"
                      src={signatureUrl + report.verify2SignatureImage}
                      alt=""
                    />
                  ) : (
                    report.verify2Signature
                  )}
                </span>
              )}
            </div>
            <div className="print-date">
              {[20, 201].includes(report.state) ? (
                <div className="printer-warning-tip">
                  风险提示：此为夜间急诊报告，请以正式报告为准
                </div>
              ) : null}
              {institutionId === 100109 ? (
                <>九峰医疗远程影像诊断中心合作</>
              ) : (
                <>
                  <img className="print-logo" alt="" src={printLogo} />
                  &nbsp;&nbsp;江西九峰远程医学影像诊断中心
                </>
              )}
              <span className="print-time">
                打印日期：{formatDA(new Date())}
              </span>
              <p className="print-tip">影像检查资料，仅为临床诊断提供参考！</p>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default withRouter(PrintReport);
